import Cell from './Cell.js'

export default class Nonogram {
    constructor(rows, columns) {
        this.rows = rows.map(digit => {
            return {
                cells: [],
                digits: ('' + digit).split(' ').map(value => {
                    return {value: value === '' ? 0 : parseInt(value, 10), is_satisfied: false}
                })
            }
        });
        this.columns = columns.map(digit => {
            return {
                cells: [],
                digits: ('' + digit).split(' ').map(value => {
                    return {value: value === '' ? 0 : parseInt(value, 10), is_satisfied: false}
                })
            }
        });

        this.cells = this.createCells();
    }

    createCells() {
        let cells = [];
        for (let i = 0; i < this.rows.length; i++) {
            for (let j = 0; j < this.columns.length; j++) {
                let cell = new Cell(i, j);
                this.rows[i].cells.push(cell);
                this.columns[j].cells.push(cell);
                cells.push(cell);
            }
        }
        return cells;
    }

    incrementCellValue(cell) {
        cell.increment();

        this.updateBoard(cell);
    }

    setCellValue(cell, value) {
        if (cell instanceof Cell === false) {
            cell = this.cells[cell];
        }
        cell.value = value;

        this.updateBoard(cell)
    }

    updateBoard(cell) {
        const good_row = this.validateRow(cell.row);
        const good_column = this.validateColumn(cell.column);

        if (good_row && good_column) {
            this.checkBoard();
        }
    }

    validate(rules, cells) {
        const regex = (new RegExp(rules.map(rule => {
            return '1{' + rule.value + '}';
        }).join('0+')));

        const how_many = rules.reduce((carry, rule) => {
            return carry + rule.value;
        }, 0);

        const str_to_match = (cells.map(cell => cell.value === 1 ? '1' : '0').join(''));
        const is_satisfied = regex.test(str_to_match) && (how_many === (str_to_match.match(/1/g) || []).length)

        rules.forEach(rule => rule.is_satisfied = is_satisfied);
        return is_satisfied;
    }

    validateRow(row) {
        row = (this.rows[row]);
        const rules = row.digits;
        const cells = row.cells;

        return this.validate(rules, cells)
    }

    validateColumn(column) {
        column = (this.columns[column]);
        const rules = column.digits;
        const cells = column.cells;

        return this.validate(rules, cells);
    }

    checkBoard() {
        for (var i = 0; i < this.rows.length; i++) {
            for (var j = 0; j < this.rows[i].digits.length; j++) {
                if (this.rows[i].digits[j].is_satisfied === false) {
                    return false;
                }
            }
        }
        for (var i = 0; i < this.columns.length; i++) {
            for (var j = 0; j < this.columns[i].digits.length; j++) {
                if (this.columns[i].digits[j].is_satisfied === false) {
                    return false;
                }
            }
        }
        window.alert('you did it!');
    }
}